import { ApiService } from '../../../shared/utils/api-servies';
const apiUrl = 'https://squid-app-tpgns.ondigitalocean.app/';
const headers = { 'telegram-data': window.Telegram.WebApp.initData };
export class TaskApiService {
    constructor() {
        this.apiService = new ApiService(apiUrl, headers);
    }
    async postTaskReward(id) {
        return this.apiService.post(`task?taskId=${id}`, {});
    }
    async checkTask(userId, groupId) {
        return this.apiService.get(`tg/check?userTgId=${userId}&groupId=${groupId}`, {});
    }
}
